<template>
    <component v-bind:is="layout"></component>
</template>

<script>
import AppLayout from './layout/AppLayout'
import SimpleLayout from './layout/SimpleLayout'
import BlankLayout from './layout/BlankLayout'

const default_layout = 'simple-layout'

export default {
  computed: {
    layout () {
      return (this.$route.meta.layout || default_layout)
    }
  },
  components: {
    'app-layout': AppLayout,
    'simple-layout': SimpleLayout,
    'blank-layout': BlankLayout
  }
}
</script>
